var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5426 5.92041C9.94436 5.92041 9.19653 6.06995 8.5983 6.3691C8.89745 6.66825 9.04699 6.96732 9.04699 7.41601C9.04699 8.31339 8.29915 8.91161 7.55139 8.91161C7.1027 8.91161 6.80355 8.76207 6.50447 8.46292C6.20533 9.06115 6.05579 9.80899 6.05579 10.4072C6.05579 12.9498 8.14968 14.8941 10.5427 14.8941C13.0852 14.8941 15.0295 12.8002 15.0295 10.4072C15.0295 8.01424 13.0851 5.92041 10.5426 5.92041Z",
    fill: "#72B81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0884 24.7653L22.358 17.8855L21.3111 18.9324L19.0677 16.689C20.2642 14.8942 21.012 12.8003 21.012 10.4073C21.012 5.32225 16.9738 0.835377 11.8887 0.0875414C4.85924 -0.809833 -1.12323 5.32225 0.222832 12.5012C0.970667 16.689 4.41056 19.9794 8.59835 20.7272C11.7392 21.3254 14.5808 20.428 16.8243 18.7829L19.0677 21.0263L18.0208 22.2228L24.7511 29.1027C25.9476 30.2992 27.8919 30.2992 28.9388 29.1027C30.2849 27.7565 30.2849 25.9618 29.0884 24.7653ZM10.5426 17.8854C6.35491 17.8854 3.06449 14.5951 3.06449 10.4073C3.06449 6.21948 6.35484 2.9292 10.5426 2.9292C14.7304 2.9292 18.0208 6.21955 18.0208 10.4073C18.0208 14.5951 14.7304 17.8854 10.5426 17.8854Z",
    fill: "#72B81F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.17fc5abeed2822d306deefc719ffc180.svg";
export { ForwardRef as ReactComponent };